import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {TableReactiveUrlController} from "@amlCore/tableReactive";
import {AccessJson, FmDraftFilter} from "@amlCore/models";
import {RoleService, TableService, VisitedService} from "@amlCore/services";
import {Utils} from "@amlCore/utils";
import {IDataResponse} from "@amlCore/interfaces";
import {NgbModal, NgbModalOptions} from "@ng-bootstrap/ng-bootstrap";
import {CommonService} from '../../../services/common.service';
import {CommonFilterService} from '../../../services/common-filter.service';
import { CommonList } from '../../../model';
import { catchError, mergeMap, takeUntil } from 'rxjs/operators';
import { Subject, forkJoin, of } from 'rxjs';
import { getDocumentConfig } from '../../../enums/documentTypeEnum';
import { CopyNotificationComponent } from 'src/app/core/components/copy-notification/copy-notification.component';

@Component({
  selector: 'app-arm-archive-list',
  templateUrl: './archive-list.component.html'
})
export class ArchiveListComponent extends TableReactiveUrlController implements OnInit, OnDestroy {

  isShowVisited = true;
  groupName: string;
  dataList: Array<CommonList> = [];
  isAll = true;
  id: string;
  access: AccessJson;
  goBack = Utils.goBack;
  private destroy$ = new Subject();
  loading: false | null = false;

  constructor(protected activatedRoute: ActivatedRoute,
              protected visitedService: VisitedService,
              protected modalDialog: NgbModal,
              protected tableService: TableService,
              protected router: Router,
              protected commonSrv: CommonService,
              protected commonFilterSrv: CommonFilterService,
              protected roleService: RoleService) {
    super(router, activatedRoute, visitedService, tableService, {sort: 'messageDate', dir: 'ASC'},
        null, null);
  }

  ngOnInit() {
    this.groupName = this.activatedRoute.snapshot?.pathFromRoot[2].routeConfig.path;

    this.activatedRoute.params.subscribe(params => {
      this.id = params.id;
      this.activatedRoute.queryParams.subscribe(
        data => {
          this.isAll = !this.id;
          const paramsData = this.syncParams(data);
          paramsData.id = this.id;
          this.loadList(paramsData);
          this.total = [];
        });
    });
    this.commonFilterSrv.loadUserAccessList(this.groupName);
    super.ngOnInit()
  }

  importLoad(data?) {
    this.onPageChange({$refresh: Math.random()});
  }

  /**
   * метод получения объекта плоского фильтра
   * @param data объект фильтра с полями
   */
  public getFilterObject(data: FmDraftFilter) {
    const filter = this.tableService.getFilterSubject(data) as FmDraftFilter;
    return this.getFilterPlanObject(filter);
  }

  public onPageChange(params) {
    const filter = this.getParams({...params, ...this.filter}) as FmDraftFilter;
    filter['isAll'] = this.isAll;
    this.navigate(filter);
  }

  public onSearch() {
    const params = this.getSearchPage(this.filter) as FmDraftFilter;
    this.onPageChange(params);
  }

  downloadDocument() {

  }

  importDocument() {

  }

  creatingFix() {

  }

  /**
   * Копирование документа
   */
  copyDocuments() {

    this.loading = null;
    const selected = this.getSelectedModel(this.dataList) as Array<CommonList>;
    const selectedObs = [];

    selected.forEach(item => selectedObs.push(this.commonSrv.copyArchiveDoc(this.groupName, item.id).pipe(catchError((err) => of( err )), mergeMap(data => of({data, itemId: item.id})))));

    forkJoin(selectedObs).pipe(takeUntil(this.destroy$)).pipe(catchError((err) => { this.loading = false; return of( err )})).subscribe((data) => {
      this.loading = false;
      const modalRef = this.modalDialog.open(CopyNotificationComponent, {
        centered: true,
        size: 'lg',
        scrollable: true
      });

      modalRef.componentInstance.items = data;

      this.importLoad();
      this.resetSelectedAll();
    } );
  }

  private loadList(params?: any) {
    this.commonSrv.getArchiveList(this.groupName, this.getParams(params)).subscribe((data: IDataResponse<CommonList>) => {
      this.dataList = data.content;
      this.total = data.totalElements;
      this.resetSelectedAll();
    });
  }

  getConfig(docType) {
    return getDocumentConfig(docType);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}


